<div class="row g-3" [formGroup]="dataForm">
  <ng-container *ngIf="data.length">
    <ng-container *ngFor="let f of data; index as i; let od = odd">
      <!-- Group Title Section -->
      <div class="col-12 mt-4" *ngIf="f?.groupTitle || f?.groupStart">
        <h6 class="text-muted border-bottom pb-2">{{ f?.groupTitle | translate }}</h6>
      </div>

      <ng-container *ngIf="!f.hidden">
        <ng-container *ngIf="f?.type != 'TEMPLATE'; else template">
          <!-- Standard Form Group -->
          <div [class.displaynone]="f?.invisible" class="form-group col-md-{{ f?.col_size ? f.col_size : '6' }} mb-3">
            <label *ngIf="!f?.hide_title" class="form-label d-flex align-items-center justify-content-between">
              <span>{{
                f?.title_case == "NONE" ? (f?.title | translate) : (f?.title | translate | titleCaseExtend)
                }}</span>

              <div class="label-actions" *ngIf="isShowDeleteBtn || isShowEditBtn">
                <span *ngIf="isShowDeleteBtn" (click)="onClickBtn('EDIT', f, i)"
                  class="cursor-pointer text-primary mx-1">
                  <i class="pi pi-pencil small"></i>
                </span>
                <span *ngIf="isShowEditBtn" (click)="onClickBtn('DELETE', f, i)"
                  class="cursor-pointer text-danger mx-1">
                  <i class="pi pi-trash small"></i>
                </span>
              </div>
            </label>

            <ng-container [ngSwitch]="f.type">
              <!-- Rich Text Editor -->
              <ng-container *ngSwitchCase="'editor'">
                <app-editor [content]="EDITOR_DATA[f?.colName]"
                  (onChangeData)="onDescriptionChange($event, f.colName)" />
              </ng-container>

              <!-- Chips -->
              <ng-container *ngSwitchCase="'chips'">
                <p-chips separator="," (onAdd)="onAddChips($event, f.colName)" [allowDuplicate]="false"
                  styleClass="w-100" inputStyleClass="form-control"
                  [formControl]="dataForm.controls[f.colName]"></p-chips>
              </ng-container>

              <ng-container *ngSwitchCase="'select'">
                <p-dropdown
                  appendTo="body"
                  [baseZIndex]="10000"
                  [name]="f.colName"
                  [options]="FORM_SUPPORT_DATA[f?.colName] || []"
                  [optionValue]="f?.selectPrimaryKey"
                  [readonly]="f?.readonly ? true : false"
                  [showClear]="f?.readonly == true ? false : true"
                  styleClass="w-100 {{
                    submitted && dataForm.get(f.colName)?.errors ? 'error' : ''
                  }}" [filter]="(FORM_SUPPORT_DATA[f?.colName]?.length || 0) > 10" [optionLabel]="f?.selectKeyName"
                  (onChange)="
                    f.event?.name == 'change' && f.event?.isCallback
                      ? onChange(f.colName, $event)
                      : f.event?.name == 'change'
                        ? getFullData(
                            f.event.apiTblName,
                            [],
                            f.event.valueAssign,
                            true,
                            f.colName,
                            f.event?.apiFunName,
                            $event
                          )
                        : ''
                  " [placeholder]="
                    DATA_LOADING[f?.colName]
                      ? ('Loading data...' | translate)
                      : (('Select' | translate) + ' ' + (f?.title | translate))
                  " [formControl]="dataForm.controls[f.colName]"></p-dropdown>
              </ng-container>

              <!-- Multi Select -->
              <ng-container *ngSwitchCase="'MULTISELECT'">
                <p-multiSelect
                  appendTo="body"
                  [baseZIndex]="10000"
                  styleClass="w-100"
                  [selectAll]="
                    MULTI_SELECT_SELECT_ALL[f.colName] == undefined
                      ? false
                      : MULTI_SELECT_SELECT_ALL[f.colName]
                  " (onChange)="
                    f.event?.name == 'change' && f.event?.isCallback
                      ? onChange(f.colName, $event)
                      : f.event?.name == 'change'
                        ? getFullData(
                            f.event.apiTblName,
                            [],
                            f.event.valueAssign,
                            true,
                            f.colName,
                            f.event?.apiFunName,
                            $event
                          )
                        : ''
                  " (onSelectAllChange)="onSelectAllChange(f, $event)" [formControl]="dataForm.controls[f.colName]"
                  [options]="FORM_SUPPORT_DATA[f?.colName]" [optionLabel]="f?.selectKeyName"
                  [optionValue]="f?.selectPrimaryKey" [placeholder]="
                    f?.placeholder ? (f.placeholder | translate) : (('Select' | translate) + ' ' + (f.title | translate))
                  "></p-multiSelect>
              </ng-container>

              <!-- Checkbox Group -->
              <ng-container *ngSwitchCase="'checkbox'">
                <div class="d-flex flex-wrap gap-3 mt-1">
                  <ng-container *ngFor="let m of FORM_SUPPORT_DATA[f?.colName]">
                    <label class="fancy-checkbox m-0">
                      <input [value]="m[f?.selectPrimaryKey]" (change)="
                          f.event?.name == 'change' && f.event?.isCallback
                            ? onChange(f.colName, $event)
                            : ''
                        " [formControl]="dataForm.controls[f.colName]" type="checkbox" />
                      <span>{{ m[f?.selectKeyName] }}</span>
                    </label>
                  </ng-container>
                </div>
              </ng-container>

              <!-- Radio Group -->
              <ng-container *ngSwitchCase="'radio'">
                <div class="d-flex flex-wrap gap-3 mt-1">
                  <ng-container *ngIf="FORM_SUPPORT_DATA[f?.colName]?.length">
                    <ng-container *ngFor="let m of FORM_SUPPORT_DATA[f?.colName]">
                      <label class="fancy-checkbox m-1">
                        <p-radioButton [inputId]="f.colName + '_' + m?.[f?.selectPrimaryKey]" [name]="f.colName"
                          [value]="m?.[f?.selectPrimaryKey]" [formControl]="dataForm.controls[f.colName]" (onClick)="
                            f.event?.name == 'change' && f.event?.isCallback
                              ? onChange(f.colName, $event)
                              : ''
                          "></p-radioButton>
                        <!-- <input
                        [value]="m[f?.selectPrimaryKey || 'id']"
                        (change)="
                          f.event?.name == 'change' && f.event?.isCallback
                            ? onChange(f.colName, $event)
                            : ''
                        "
                        [formControl]="dataForm.controls[f.colName]"
                        [name]="f.colName"
                        type="radio"
                      /> -->
                        <span> {{ m[f?.selectKeyName] }}</span>
                      </label>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>

              <!-- Textarea -->
              <textarea *ngSwitchCase="'TEXTAREA'" class="form-control" rows="4" (paste)="removeWhiteSpace()"
                [class.error]="submitted && dataForm.get(f.colName)?.errors"
                [formControl]="dataForm.controls[f.colName]" [placeholder]="
                  f?.placeholder ? (f.placeholder | translate) : (('Enter' | translate) + ' ' + (f.title | translate))
                "></textarea>

              <!-- Date / Calendar -->
              <ng-container *ngSwitchCase="'DATE'">
                <p-calendar
                  appendTo="body"
                  [baseZIndex]="10000"
                  #calender
                  [disabled]="f?.readonly"
                  [showOnFocus]="!f?.readonly"
                  [readonlyInput]="f?.readonly"
                  [dateFormat]="f?.dateFormat || dateFormat"
                  [view]="f?.dateViewMode || 'date'"
                  [formControl]="dataForm.controls[f.colName]"
                  (onSelect)="onChange(f.colName, $event)"
                  [showTime]="f?.showTime"
                  [showSeconds]="f?.showSeconds"
                  [timeOnly]="f?.timeOnly"
                  styleClass="w-100 {{
                    submitted && dataForm.get(f.colName)?.errors ? 'error' : ''
                  }}" [minDate]="f?.minDate || undefined" [maxDate]="f?.maxDate || undefined"
                  [monthNavigator]="f?.monthNavigator" [yearRange]="f?.dateRange" [yearNavigator]="f?.yearNavigator"
                  inputStyleClass="form-control" [placeholder]="
                    f?.placeholder ? (f.placeholder | translate) : (('Select' | translate) + ' ' + (f.title | translate))
                  " [selectionMode]="f?.selectionMode || 'single'"></p-calendar>
              </ng-container>

              <!-- Datetime -->
              <ng-container *ngSwitchCase="'DATETIME'">
                <p-calendar
                  appendTo="body"
                  [baseZIndex]="10000"
                  [disabled]="f?.readonly"
                  [dateFormat]="f?.dateFormat || dateFormat"
                  hourFormat="12"
                  [readonlyInput]="true"
                  [view]="f?.dateViewMode || 'date'"
                  [formControl]="dataForm.controls[f.colName]"
                  (onSelect)="onChange(f.colName, $event)"
                  [showTime]="f?.showTime"
                  [showSeconds]="f?.showSeconds"
                  [timeOnly]="f?.timeOnly"
                  styleClass="w-100 {{
                    submitted && dataForm.get(f.colName)?.errors ? 'error' : ''
                  }}" [monthNavigator]="f?.monthNavigator" [yearRange]="f?.dateRange"
                  [yearNavigator]="f?.yearNavigator" inputStyleClass="form-control" [placeholder]="
                    f?.placeholder ? (f.placeholder | translate) : (('Select' | translate) + ' ' + (f.title | translate))
                  "></p-calendar>
              </ng-container>
              <ng-container *ngSwitchCase="'formArray'">
                <app-form-array [parentForm]="dataForm" [arrayName]="f.colName" [fields]="f.formArray"
                  (arrayChanged)="onChangeEvent.emit($event)"></app-form-array>
              </ng-container>
              <ng-container *ngSwitchCase="'FILE'">
                <app-image-upload *ngIf="f?.type == 'FILE'" #imageUploader
                  (uploadedFileInfo)="didUpload($event, f?.colName)" [inputFile]="fileConfig[f?.colName]">
                </app-image-upload>
              </ng-container>
              <ng-container *ngSwitchCase="'INFO'">
                <span *ngIf="f?.controlAction?.operation == 'MULTIPLE'">
                  {{
                  dataForm?.value[f?.controlAction.controls[0]] *
                  dataForm?.value[f?.controlAction.controls[1]]
                  }}
                  {{ f?.controlAction.info_text || "" }}</span>
                <span *ngIf="f?.controlAction?.operation == 'ADD'">{{
                  f?.controlAction.controls[0] + f?.controlAction.controls[1]
                  }}
                  {{ f?.controlAction.info_text || "" }}</span>
              </ng-container>
              <!-- Autocomplete -->
              <ng-container *ngSwitchCase="'AUTOCOMPLETE'">
                <p-autoComplete
                  [baseZIndex]="10000"
                  [formControl]="dataForm.controls[f.colName]"
                  [multiple]="f?.selectionMode == 'multiple'"
                  styleClass="w-100 {{
                    submitted && dataForm.get(f.colName)?.errors ? 'error' : ''
                  }}" [placeholder]="('Search' | translate) + ' ' + (f?.title | translate)"
                  inputStyleClass="form-control" [inputStyle]="{ width: '100%' }"
                  [suggestions]="FORM_SUPPORT_DATA[f?.colName]" [forceSelection]="true" [itemSize]="10"
                  (onSelect)="onSelectAutocomplete($event, f)" (completeMethod)="filterItems($event, f)"
                  [field]="f?.selectKeyName">
                  <ng-template let-item pTemplate="item">
                    <span class="autocomplete-label">
                      <ng-container *ngIf="f.autoSearch?.selectFieldKeys; else showdf">
                        <span *ngFor="
                            let a of f.autoSearch?.selectFieldKeys;
                            let last = last
                          ">
                          {{ item[a] }}{{ !last ? " | " : "" }}
                        </span>
                      </ng-container>
                      <ng-template #showdf>{{
                        item[f?.selectKeyName]
                        }}</ng-template>
                    </span>
                  </ng-template>
                </p-autoComplete>
              </ng-container>

              <!-- Color Picker -->
              <ng-container *ngSwitchCase="'COLORPICKER'">
                <div class="color-picker-wrapper">
                  <p-colorPicker [formControl]="dataForm.controls[f.colName]" (change)="
                      f.event?.name == 'change'
                        ? onChange(f.colName, $event)
                        : ''
                    " (click)="
                      f.event.name == 'click' ? onChange(f.colName, $event) : ''
                    " [disabled]="f?.readonly" appendTo="body" [baseZIndex]="20000" [inline]="f?.inline"></p-colorPicker>
                  <div class="color-details">
                    <span class="color-swatch" [style.background-color]="
                        dataForm.controls[f.colName]?.value
                      "></span>
                    <span class="color-code">{{
                      dataForm.controls[f.colName]?.value || "#000000"
                      }}</span>
                  </div>
                </div>
              </ng-container>

              <!-- Default / Text Input -->
              <ng-container *ngSwitchDefault>
                <div class="input-group">
                  <span class="p-input-icon-right w-100" [class.p-input-icon-left]="
                      f?.icon_append?.category == 'PREPAND'
                    ">
                    <i *ngIf="f?.icon_append?.icon" [className]="f?.icon_append?.icon"></i>
                    <i *ngIf="dataForm?.get(f.colName)?.pending" class="pi pi-spin pi-spinner"></i>

                    <input pInputText class="form-control w-100" [class.error]="
                        submitted && dataForm.get(f.colName)?.errors
                      " [pKeyFilter]="f?.inputKeyFilter || defaultKeyFilter"
                      [formControl]="dataForm.controls[f.colName]" [readonly]="f?.readonly" (change)="
                        f?.event?.name == 'change'
                          ? onChange(f.colName, $event)
                          : ''
                      " (input)="
                        f?.event?.name == 'input'
                          ? onInput(f.colName, f.event)
                          : ''
                      " (paste)="removeWhiteSpace()"
                      [placeholder]="f?.placeholder ? (f.placeholder | translate) : (f?.title | translate)"
                      type="text" />
                  </span>
                  <div class="input-group-append" *ngIf="
                      f?.icon_append?.text &&
                      f?.icon_append?.category == 'APPEND'
                    ">
                    <span class="input-group-text border-left-0">{{
                      f?.icon_append?.text
                      }}</span>
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <!-- Helper Text & Validation Errors -->
            <div class="helper-text-container" *ngIf="f?.info">
              <i class="pi pi-info-circle mr-1"></i>
              <small class="helper">{{ f.info }}</small>
            </div>

            <div class="error-container" *ngIf="submitted && dataForm?.get(f.colName)?.errors">
              <ng-container *ngFor="let val of f.validator">
                <span class="error" *ngIf="dataForm?.get(f.colName)?.errors[val?.name]">
                  <i class="pi pi-exclamation-circle mr-1"></i> {{ val?.error | translate }}
                </span>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <!-- Template Injection -->
        <ng-template #template>
          <ng-container *ngIf="formBody">
            <div [class.displaynone]="f?.invisible" class="form-group col-md-{{
                f?.col_size ? f.col_size : '6'
              }} mb-3">
              <ng-container [ngTemplateOutlet]="formBody"
                [ngTemplateOutletContext]="{ colName: f?.colName, formData: f }"></ng-container>
            </div>
          </ng-container>
        </ng-template>
      </ng-container>
    </ng-container>
  </ng-container>
</div>